if (!customElements.get('sticky-header')) {
  customElements.define('sticky-header', class Header extends HTMLElement {
    constructor() {
      super();
      
      this.navToggle = this.querySelector('.link-hamburger');
      this.headerNav = this.querySelector('.header_nav');
      this.navToggle.addEventListener('click', ( event ) => this.toggle() );
      this.topBar = this.querySelector('.menu-accessor');
      this.headerHeight = this.offsetHeight;

      this.subNavs = document.querySelectorAll('.nav_link .link');
      this.subNavs.forEach((subnav) => {
        subnav.addEventListener('click', function(e){
          if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            e.preventDefault();
            if (e.target.tagName == 'SPAN') {
              const parent = e.target.parentElement
              var subnavmenu = document.querySelector(parent.getAttribute('data-target'));
              subnavmenu.classList.add('active');
            } else {
              var subnavmenu = document.querySelector(e.target.getAttribute('data-target'));
              subnavmenu.classList.add('active');
            }
          }
        })
      })

      this.submenus = document.querySelectorAll('.nav_submenu_left_links a');
      this.submenus.forEach((submenu) => {
        submenu.addEventListener('mouseover', function(e){
          if(e.target.hash){
            e.preventDefault();
            var submenu_trigger = e.target.hash;
            if(document.querySelector('[data-trigger="'+submenu_trigger+'"]')) {
              e.target.offsetParent.querySelector('.nav_submenu_right').style.display='none';
              document.querySelector('[data-trigger="'+submenu_trigger+'"]').style.display="block";
            }
          }else{
            document.querySelectorAll('.nav_submenu_right').forEach((nav_submenu) => {
              nav_submenu.style='';
            })
          }
        })
        
        submenu.addEventListener('click', function(e){
          if(e.target.hash){
            e.preventDefault();
            var submenu_trigger = e.target.hash;
            if(document.querySelector('[data-trigger="'+submenu_trigger+'"]')) {
              e.target.offsetParent.querySelector('.nav_submenu_right').style.display='none';
              document.querySelector('[data-trigger="'+submenu_trigger+'"]').style.display="block";
            }
          }else{
            document.querySelectorAll('.nav_submenu_right').forEach((nav_submenu) => {
              nav_submenu.style='';
            })
          }
        })
      })

      this.subNavBacks = document.querySelectorAll('.nav_submenu_back a');
      this.subNavBacks.forEach((subback) => {
        subback.addEventListener('click', function(e){
          e.target.closest('.nav_submenu').classList.remove('active');
        });
      });

      this.headerSearchAccessor = document.querySelector('.header_search .link');
      this.headerSearchAccessorMobile = document.querySelector('.header_search .link-mobile');
      this.headerSearchForm = document.querySelector('.header_search_form');
      this.headerSearchFormMobile = document.querySelector('.header_search_form_mobile');
      this.headerSearchClose = document.querySelector('.header_search_close');
      this.headerSearchCloseMobile = document.querySelector('.header_search_close_mobile');
    
      this.headerSearchAccessor.addEventListener('click', function(e){
        e.preventDefault();
        document.querySelector('.header_search_form').classList.add('active');
      })
      this.headerSearchAccessorMobile.addEventListener('click', function(e){
        e.preventDefault();
        document.querySelector('.header_search_form_mobile').classList.add('active');
        document.querySelector('.cart-icon-bubble-mobile').style.display = 'none';
        document.querySelector('.link-hamburger-mobile').style.display = 'none';
        document.querySelector('.header_search_mobile').style.display = 'none';
      })
      this.headerSearchClose.addEventListener('click', function(e){
        e.preventDefault();
        document.querySelector('.header_search_form').classList.remove('active');
      })
      this.headerSearchCloseMobile.addEventListener('click', function(e){
        e.preventDefault();
        document.querySelector('.header_search_form_mobile').classList.remove('active');
        document.querySelector('.cart-icon-bubble-mobile').style.display = 'block';
        document.querySelector('.link-hamburger-mobile').style.display = 'flex';
        document.querySelector('.header_search_mobile').style.display = 'block';
      })
      
      this.headerSearchForm.addEventListener('click', function(e){
        console.log(e.target);
        if(e.target.classList.contains('header_search_form')) document.querySelector('.header_search_form').classList.remove('active');
      })
      this.headerSearchFormMobile.addEventListener('click', function(e){
        console.log(e.target);
        if(e.target.classList.contains('header_search_form_mobile')) document.querySelector('.header_search_form_mobile').classList.remove('active');
      })
      this.init();
    }

    init() {
      this.stickyHeader();

    }
    
    stickyHeader() {
      const announcement = document.getElementById('shopify-section-announcement-bar');
      const announcementContainer = announcement.querySelector('.announcement-bar');
      const announcementHeight = announcement.offsetHeight - 1;
      const totalHeight = this.headerHeight + announcementHeight -1;

      if (announcement.childNodes.length > 1) {
        document.addEventListener('scroll', () => {
          if(document.documentElement.scrollTop > totalHeight - 35) {
            this.classList.add('sticky');
            announcementContainer.classList.add('sticky');
            announcementContainer.style.top = announcementHeight + 'px';
            this.style.top = totalHeight + 'px';
            this.topBar.style.transform = "translateY 15%)";
            if (this.topBar.classList.contains('active')) {
              this.topBar.style.transform = "translateY(50%)";
            }
          } else {
            this.topBar.style.transform = null;
            this.classList.remove('sticky');
            announcementContainer.classList.remove('sticky');
            this.style.top = '0px';
          }
          if (document.documentElement.scrollTop == 0) {
            this.topBar.style.transform = null;
            this.classList.remove('sticky');
            announcementContainer.classList.remove('sticky');
            this.style.top = '0px';
          }
        });
      } else {
        document.addEventListener('scroll', () => {
          if(document.documentElement.scrollTop > totalHeight - 35) {
            this.classList.add('sticky');
            announcementContainer.classList.add('sticky');
            announcementContainer.style.top = announcementHeight + 'px';
            this.style.top = totalHeight + 'px';
            this.topBar.style.transform = "translateY 15%)";
            if (this.topBar.classList.contains('active')) {
              this.topBar.style.transform = "translateY(50%)";
            }
          } else {
            this.topBar.style.transform = null;
          }
          if (document.documentElement.scrollTop == 0) {
            this.topBar.style.transform = null;
            this.classList.remove('sticky');
            announcementContainer.classList.remove('sticky');
            this.style.top = '0px';
          }
        });
      }
    }

    

	toggle(){
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        if(this.navToggle.classList.contains('active')) {
          this.headerNav.style = '';
        }else{
        	this.headerNav.style.transform = "translateX(0)";
        }
        this.navToggle.classList.toggle('active');
        document.querySelector('body').classList.toggle('disable-scroll');
        document.getElementsByTagName('html')[0].classList.toggle('disable-scroll-html');
      } else {
        if(this.navToggle.classList.contains('active')) {
          this.headerNav.style = '';
        }else{
        	this.headerNav.style.transform = "translateX(0)";
        }
        this.navToggle.classList.toggle('active');
        document.querySelector('body').classList.toggle('disable-scroll');
        document.getElementsByTagName('html')[0].classList.toggle('disable-scroll-html');
      }
      
	}
 

  });
 

  
}
